import { Lock, Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/hooks/use-subscription";

const FEATURE_LABELS: Record<string, { name: string; plan: string }> = {
  budget_planning: { name: "Planejamento Financeiro", plan: "Starter" },
  dre_reports: { name: "Relatório DRE", plan: "Colab" },
  bank_import: { name: "Importação de Extratos", plan: "Starter" },
  statement_import: { name: "Importação de Extratos", plan: "Starter" },
  recurring_management: { name: "Gestão de Recorrentes", plan: "Starter" },
  smart_alerts: { name: "Alertas Inteligentes", plan: "Starter" },
  account_sharing: { name: "Compartilhamento de Contas", plan: "Colab" },
  multi_user: { name: "Múltiplos Usuários", plan: "Colab" },
  advanced_reports: { name: "Relatórios Avançados", plan: "Starter" },
  goal_tracking: { name: "Acompanhamento de Metas", plan: "Starter" },
  custom_categories: { name: "Categorias Personalizadas", plan: "Starter" },
  max_checking_accounts: { name: "Contas Corrente", plan: "Starter" },
  max_savings_accounts: { name: "Contas Poupança", plan: "Starter" },
  max_credit_cards: { name: "Cartões de Crédito", plan: "Starter" },
  credit_card_access: { name: "Cartão de Crédito", plan: "Starter" },
  transfers_access: { name: "Transferências entre Contas", plan: "Starter" },
  max_goals: { name: "Cofrinhos", plan: "Starter" },
  provisions: { name: "Provisões", plan: "Starter" },
  max_shared_users: { name: "Usuários Compartilhados", plan: "Colab" },
};

interface UpgradePromptProps {
  feature: string;
}

export function UpgradePrompt({ feature }: UpgradePromptProps) {
  const { openCheckout } = useSubscription();

  const featureInfo = FEATURE_LABELS[feature] ?? {
    name: feature,
    plan: "Starter",
  };

  return (
    <Card className="border-dashed border-2 border-primary/30 bg-primary/5">
      <CardContent className="flex flex-col items-center justify-center py-8 text-center gap-4">
        <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
          <Lock className="h-6 w-6 text-primary" />
        </div>
        <div className="space-y-1">
          <h3 className="text-lg font-semibold">
            {featureInfo.name}
          </h3>
          <p className="text-sm text-muted-foreground max-w-sm">
            Esse recurso está disponível no plano{" "}
            <span className="font-medium text-primary">{featureInfo.plan}</span>.
            Faça um upgrade para desbloquear.
          </p>
        </div>
        <Button
          onClick={() => openCheckout("starter")}
          className="gap-2"
        >
          <Sparkles className="h-4 w-4" />
          Experimentar Grátis
        </Button>
      </CardContent>
    </Card>
  );
}
